export default __webpack_public_path__ + "static/AYVAKIT_Product_Pricing_Sheet_HCP-a4021c1e603dd3dc7bb3209bcb82379d.pdf";